import { render, staticRenderFns } from "./ValuesPanel.vue?vue&type=template&id=1d340afd&scoped=true&"
import script from "./ValuesPanel.vue?vue&type=script&lang=ts&"
export * from "./ValuesPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ValuesPanel.vue?vue&type=style&index=0&id=1d340afd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d340afd",
  null
  
)

export default component.exports